export const COMMISSION_LIST = 'COMMISSION_LIST';
export const COMMISSION_LADIFLOW_LIST = 'COMMISSION_LADIFLOW_LIST';
export const COMMISSION_DETAIL = 'COMMISSION_DETAIL';
export const MY_COMMISSION = 'MY_COMMISSION';
export const CREATE_INVOICE = 'CREATE_INVOICE';
export const EXPORT_COMMISSION = 'EXPORT_COMMISSION';
export const EXPORT_COMMISSION_LADIFLOW = 'EXPORT_COMMISSION_LADIFLOW';

